import React from 'react';
import {
  injectIntl,
} from 'react-intl';

export default injectIntl(({intl}) => {
  var rawMessage = intl.messages["title"];
  if(typeof rawMessage === "undefined" || rawMessage === ""){
    return null; 
  } else {
    var message = intl.formatMessage({id: "title", });
    return (
      <React.Fragment>{message}</React.Fragment>
    );
  }
  
});
